module.exports = __webpack_public_path__ + "img/lang.60faee64.jpeg";